import React from 'react'
import { DialogOverlay, Bleed, Separator, LayoutBand, useContainerWidth, H2, Paragraph, colors } from '@fs/zion-ui'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import Leaderboard from '../LeaderBoard'
import { useFamilyGroupContext } from '../../providers/FamilyGroupProvider'
import CloudBackground from '../LeaderBoard/CloudBackground'
import FamilyGroupCardFactory from '../FamilyGroupCard/FamilyGroupCardFactory'

const noGroupCss = css`
  text-align: center;
  min-height: 300px;
  z-index: 1;
  position: relative;
  h2 {
    margin-top: 10%;
    margin-bottom: 5%;
  }
`

export default function LeaderboardOverlay({ overlay }) {
  const { t } = useTranslation()
  const { familyGroup, familyGroups, setFamilyGroup, loadFamilyGroup } = useFamilyGroupContext()
  const atWidth = useContainerWidth()
  const familyGroupsLoaded = familyGroups
  return (
    <DialogOverlay {...overlay} title={t('leaderboard.leaderboard', 'Leaderboard')}>
      <Bleed top bottom>
        <LayoutBand
          css={css`
            background: linear-gradient(180deg, ${colors.yellow10} 58.57%, ${colors.yellow05} 100%);
            min-height: ${atWidth({ default: `calc(100vh - 64px)`, md: '100%' })};
          `}
        >
          {familyGroupsLoaded && familyGroups.length > 1 ? (
            <Leaderboard familyGroups={familyGroups} familyGroup={familyGroup} setFamilyGroup={setFamilyGroup} />
          ) : (
            <div>
              <CloudBackground />
              <div css={noGroupCss}>
                <H2 size="H3">{t('leaderboard.no.group', 'You are not currently in a family group')}</H2>
                <Paragraph>{t('leaderboard.join', 'Create or Join a group to explore the leaderboard!')}</Paragraph>
              </div>
              <FamilyGroupCardFactory familyGroups={familyGroups} refreshGroups={loadFamilyGroup || (() => {})} />
            </div>
          )}
          <Separator size="md" />
        </LayoutBand>
      </Bleed>
    </DialogOverlay>
  )
}
